import request from "@/utils/request";

const state = {
    balance:100000
}

const mutations = {
    SET_BALANCE(state, balance) {
        state.balance = balance
    },
}

const actions = {

}

const getters = {
    walletInfo: state => !!state.balance,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}